module.exports = __webpack_public_path__ + "static/media/solution-3-sec1.130652cb.png";